module.exports = __webpack_public_path__ + "voted.9549908f.png";